module.exports = __webpack_public_path__ + "static/img/002@2x.32ef2532.png";